"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverAnimation = void 0;
var tslib_1 = require("tslib");
var framer_motion_1 = require("framer-motion");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var animationDirections = {
    up: {
        x: 0,
        y: 10,
    },
    down: {
        x: 0,
        y: -10,
    },
    left: {
        x: -10,
        y: 0,
    },
    right: {
        x: 10,
        y: 0,
    },
};
function PopoverAnimation(props) {
    var isOpen = props.isOpen, children = props.children, direction = props.direction;
    var _a = animationDirections[direction], x = _a.x, y = _a.y;
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, isOpen && (react_1.default.createElement(framer_motion_1.motion.div, { initial: { x: x, y: y, opacity: 0 }, animate: { x: 0, y: 0, opacity: 1, transition: { type: 'spring', damping: 20, stiffness: 300 } }, exit: {
            y: y,
            x: x,
            opacity: 0,
            transition: {
                type: 'tween',
                duration: 0.3,
            },
        } }, children))));
}
exports.PopoverAnimation = PopoverAnimation;
//# sourceMappingURL=index.js.map